import
  React
from 'react';

import {
  PropTypes
} from 'prop-types';

import {
  useHistory
} from 'react-router-dom';

import {
  HContainer,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from 'constants';

export const Just4YouSocialBundleContainer = props => {

  const history = useHistory();

  const handleBundleClick = bundle => {

    if (props.isBundleActivated){

      props.onHandleUtagLinkEvent(`activation successful: ${bundle}`);

      history.push('/home');

      return;
    }

    props.onHandleUtagLinkEvent(`activation unsuccessful: ${bundle}`);
    history.push('/home');
  };

  const sortedBundles = [ ...props.vasList ].sort((a, b) => b.price - a.price);

  const top3Bundles = sortedBundles.slice(0, 3);

  return (
    <VContainer
      height={'100%'}
      minHeight={'259px'}
      maxHeight={'629px'}
      width={'344px'}>

      <Text
        lineHeight={'24px'}
        width={'320px'}
        margin={'25px 12px 12px'}
        color={CustomColors.Black5}
        fontSize={'18px'}
        fontWeight={'700'}>
        { props.isBundleActivated ? 'More great deals Just 4 You' : 'These data deals are Just 4 You!' }
      </Text>

      {top3Bundles.map((item, index) => (
        <HContainer
          key={index}
          width={'330px'}
          height={'164px'}
          margin={'0 12px 18px'}
          onClick={() => handleBundleClick(item?.description)}
          boxShadow={`0px 0px 15px 0px ${CustomColors.TransparentBlack1}`}
          borderRadius={'8px'}>

          <VContainer
            width={'165px'}
            borderRadius={'8px 0px 0px 8px'}
            background={CustomColors.GradientBlue2}>

            <Text
              lineHeight={'22px'}
              margin={ item.description.length > 5 ? '60px 0px 0px 40px':'74px 0px 0px 26px'}
              color={CustomColors.White}
              fontSize={ item.description.length > 5 ? '20px' : '28px'}
              fontWeight={'700'}>
              {`${item.description.split('|')[0].trim().replace('VC min', 'Vodacom minutes')}`}
            </Text>

          </VContainer>

          <VContainer
            width={'136px'}
            margin={'0px 0px 0px 14px'}
            borderRadius={'0px 8px 8px 0px'}
            backgroundColor={CustomColors.White}>

            <Image
              alignSelf={'end'}
              src={Icons.Just4You}
              width={'40px'}
              height={'40px'}/>

            <Text
              margin={'19px 0px 0px 0px'}
              lineHeight={'48px'}
              color={CustomColors.Black5}
              fontSize={'29px'}
              fontWeight={'700'}>
              {`Only R${item.price}`}
            </Text>

            <Text
              margin={'0px 0px 0px 5px'}
              width={'91px'}
              lineHeight={'18px'}
              color={CustomColors.Black5}
              fontSize={'12px'}
              fontWeight={'400'}>
              {`Valid for ${item.bundleDuration} ${item.bundleDurationUom?.toLowerCase()}`}
            </Text>
          </VContainer>
        </HContainer>
      ))}
    </VContainer>
  );
};

Just4YouSocialBundleContainer.propTypes = {
  vasList: PropTypes.arrayOf(PropTypes.object),
  onHandleUtagLinkEvent: PropTypes.func,
  isBundleActivated: PropTypes.bool
};